import React from "react";
import CG_FooterButtons from "./CG_FooterButtons";

export default function CG_OfferDetails({ setFormData, formData, setCurrentScreen, currentScreen, navigate, screen }) {
    const handleNext = (e) => {
        e.preventDefault();
        if (!formData.price || !formData.contingencies1 || !formData.size1 || !formData.stories1) {
            alert("Please fill out all required fields.");
            return;
        }
        setCurrentScreen(2);
        console.log("Form submitted successfully:", formData);
        // Proceed with further actions, such as navigating or API calls.
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((pre) => ({ ...pre, [name]: value }));
    };
    return (
        <form onSubmit={handleNext} className="tw-h-full tw-flex tw-flex-col tw-justify-between">
            <div className="tw-flex tw-w-full tw-flex-col  tw-px-3 tw-items-center">
                <h2 className="tw-mt-5 tw-text-center tw-font-[700] tw-text-[30px] tw-text-[#001659]">Offer Details</h2>
                <div className="tw-w-full lg:tw-w-[70%]  tw-flex tw-flex-col tw-items-center tw-gap-2 tw-mt-5">
                    <div className="tw-w-full">
                        <p className="tw-font-[600]">Offered Price:</p>
                        <input
                            placeholder="Enter your Price"
                            name="price"
                            value={formData.price}
                            onChange={handleInputChange}
                            required
                            className="tw-bg-[#f1f1f1] tw-w-full tw-rounded-md tw-px-2 tw-py-1"
                        />
                    </div>
                    <div className="tw-w-full">
                        <p className="tw-font-[600]">Contingencies:</p>
                        <select
                            value={formData.contingencies1}
                            onChange={handleInputChange}
                            required
                            name="contingencies1"
                            className="tw-bg-[#f1f1f1] tw-w-full tw-rounded-md tw-px-2 tw-py-1"
                        >
                            <option value={""}>Select Contingencies</option>
                            <option value={"House"}>House</option>
                            <option value={"Plote"}>Plote</option>
                            <option value={"Agriculture"}>Agriculture</option>
                        </select>
                    </div>
                    <div className="tw-w-full">
                        <p className="tw-font-[600]">Contingencies:</p>
                        <div className="tw-bg-[#f1f1f1] tw-w-full tw-rounded-md tw-flex tw-justify-between tw-px-2 tw-py-1">
                            <input
                                placeholder="Enter Size"
                                value={formData.contingencies2}
                                onChange={handleInputChange}
                                required
                                name="contingencies2"
                                className="tw-w-[80%] tw-bg-transparent tw-outline-none"
                            />
                            <select className="tw-rounded-md">
                                <option>Select Number</option>
                                <option>Sqft</option>
                                <option>Sqft</option>
                            </select>
                        </div>
                    </div>
                    <div className="tw-w-full">
                        <p className="tw-font-[600]">Option:</p>
                        <input
                            placeholder="Enter your option"
                            value={formData.option1}
                            onChange={handleInputChange}
                            required
                            name="option1"
                            className="tw-bg-[#f1f1f1] tw-w-full tw-rounded-md tw-px-2 tw-py-1"
                        />
                    </div>
                    <div className="tw-w-full">
                        <p className="tw-font-[600]">Option:</p>
                        <input
                            placeholder="Enter your option"
                            value={formData.option2}
                            onChange={handleInputChange}
                            required
                            name="option2"
                            className="tw-bg-[#f1f1f1] tw-w-full tw-rounded-md tw-px-2 tw-py-1"
                        />
                    </div>
                </div>
            </div>
            <CG_FooterButtons currentScreen={currentScreen} setCurrentScreen={setCurrentScreen} navigate={navigate} />
        </form>
    );
}
